import './FeedbackModal.scss';
class BuilderFeedbackVotesModalController {
    static $inject = ['close', 'body', 'buttons'];
    constructor(close, body, buttons) {
        this.close = close;
        this.body = body;
        this.buttons = buttons;
        this._close = this.close;
    }
    _positive() {
        this.buttons?.like?.action();
        this._close();
    }
    _negative() {
        this.buttons?.deslike?.action();
        this._close();
    }
}
BuilderFeedbackVotesModalController.$inject = ['close', 'body', 'buttons'];
export default BuilderFeedbackVotesModalController;
